import { ParamMap, Params } from '@angular/router';
import { ExpeditionStatus } from 'src/app/models/enums';
import { parseEnumList, serializeStringList } from './filterUtils';

export interface IAvailabilitiesFilters {
  selectedStatus: ExpeditionStatus[];
  bookings: boolean | undefined;
  fromDate: string | undefined;
  toDate: string | undefined;
  startTime: string | undefined;
  endTime: string | undefined;
}

export const AVAILABILITY_FILTER_KEYS = [
  'status', 'bookings', 'fromDate', 'toDate', 'startTime', 'endTime'
] as const;

export function serializeAvailabilitiesFilters(f: IAvailabilitiesFilters): Params {
  return {
    status: serializeStringList(f.selectedStatus),
    bookings: f.bookings === undefined ? null : (f.bookings ? 'true' : 'false'),
    fromDate: f.fromDate || null,
    toDate: f.toDate || null,
    startTime: f.startTime || null,
    endTime: f.endTime || null,
  };
}

export function deserializeAvailabilitiesFilters(params: ParamMap): IAvailabilitiesFilters {
  const bookingsRaw = params.get('bookings');
  return {
    selectedStatus: parseEnumList<ExpeditionStatus>(params.get('status')),
    bookings: bookingsRaw === 'true' ? true : (bookingsRaw === 'false' ? false : undefined),
    fromDate: params.get('fromDate') ?? undefined,
    toDate: params.get('toDate') ?? undefined,
    startTime: params.get('startTime') ?? undefined,
    endTime: params.get('endTime') ?? undefined,
  };
}
